module.exports = __webpack_public_path__ + "img/DemoEnglish.6d43af5a.png";